import React from 'react';

const UnauthorizedDomainModal = ({
  isOpen,
  domain,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl max-w-md w-full overflow-hidden border border-gray-100 dark:border-slate-800 animate-in zoom-in-95 duration-200">
        <div className="p-8 text-center">
          {/* Icon Header */}
          <div className="w-16 h-16 bg-red-100 dark:bg-red-950/40 text-red-600 dark:text-red-400 rounded-full flex items-center justify-center mx-auto mb-5 shadow-inner">
            <i className="fas fa-exclamation-circle text-2xl"></i>
          </div>

          {/* Title */}
          <h2 className="text-xl font-extrabold text-gray-800 dark:text-slate-100 mb-2">
            Dominio No Autorizado
          </h2>

          {/* Context Domain Badge if available */}
          {domain && (
            <div className="inline-flex items-center space-x-1.5 px-3 py-1 bg-red-50 dark:bg-red-950/50 border border-red-200/60 dark:border-red-900/40 rounded-lg text-xs font-bold text-red-700 dark:text-red-300 mb-4">
              <i className="fas fa-globe text-[10px]"></i>
              <span>{domain}</span>
            </div>
          )}

          {/* Content Description */}
          <p className="text-sm text-gray-600 dark:text-slate-400 mb-8 leading-relaxed">
            No tienes autorización para ver la información de este dominio. Por favor, verifica que el nombre del dominio esté bien escrito o que tu usuario tenga los permisos necesarios asignados.
          </p>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full bg-slate-800 hover:bg-slate-900 text-white dark:bg-slate-700 dark:hover:bg-slate-600 font-bold py-3 px-6 rounded-xl transition-all shadow-lg shadow-slate-200 dark:shadow-none hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center space-x-2 text-sm uppercase tracking-wider"
          >
            <i className="fas fa-check"></i>
            <span>Entendido</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedDomainModal;
